import { useState } from 'react';

import copyTextToClipboard from 'ggApp/utils/copyToClipboard';

type UseCopyHookProps = {
    textToCopy?: string;
    displayText: string;
    onCopied?: () => void;
};

export default function useCopy({
    textToCopy,
    displayText,
    onCopied,
}: UseCopyHookProps): { isActive: boolean; copyToClipboard: () => void } {
    const [isActive, setActive] = useState(false);

    const copyToClipboard = (): void => {
        const text = textToCopy || displayText;
        copyTextToClipboard({ text });
        setActive(true);
        if (onCopied) {
            onCopied();
        }

        setTimeout(() => setActive(false), 2000);
    };

    return { isActive, copyToClipboard };
}
